import { v4 as uuid } from 'uuid';
export const translateWaitMusic = (waitMusicItem) => ({
    id: waitMusicItem.id,
    name: waitMusicItem.name,
    url: waitMusicItem.original_as_mp3_url || waitMusicItem.chunk_urls[0],
});
export const translateAnnouncement = (announcementItem) => {
    const [_, id] = announcementItem.url.match(
    /*
     * Match the UUID of the URL in a group
     * e.g https://aws.io/1d-w3-d0nt-c4re/announcement/(matches this part).wav
     */
    /.+\/(.+)\..{2,5}$/) || [];
    return {
        id: id || uuid(),
        name: announcementItem.pretty_name,
        url: announcementItem.url,
    };
};
